<div class="home-card">
    <div class="title d-flex justify-content-between">
        <h3>{{ 'home.widgetConnect.title' | translate }}</h3>
        <button
            pButton
            pRipple
            type="button"
            icon="pi pi-filter"
            class="p-button-rounded p-button-text p-button-plain"
            pTooltip="{{ 'home.widgetConnect.updateFilters' | translate }}"
            tooltipPosition="top"
            (click)="openSearchContactModal()"
            [appTrack]="'homepage_recommendation_update_filters_clicked'"
        ></button>
    </div>
    <div class="mt-2" *ngIf="isLoading; else userList"></div>

    <ng-template #userList class="list">
        <div class="mt-3" *ngIf="users.length > 0; else noUsersMessage">
            <ul class="row list-participants">
                <li class="p-0" *ngFor="let user of users" (click)="openProfileModal(user)">
                    <app-user-avatar
                        class="cursor-pointer"
                        [firstName]="user.firstName"
                        [lastName]="user.lastName"
                        [picture]="user.pictureReference"
                        [appTrack]="'homepage_recommendation_profile_clicked'"
                        [appTrackParams]="{
                            target_user_id: user.id
                        }"
                    ></app-user-avatar>
                </li>
                <li>
                    <button
                        pButton
                        pRipple
                        type="button"
                        icon="icon-loop2"
                        class="button-refresh"
                        pTooltip="{{ 'home.widgetConnect.refresh' | translate }}"
                        tooltipPosition="top"
                        (click)="refreshUsers()"
                        [appTrack]="'homepage_recommendation_refreshed_clicked'"
                    ></button>
                </li>
            </ul>
        </div>
        <ng-template #noUsersMessage>
            <div class="mt-3 text-muted">
                <div class="d-flex flex-column">
                    <ng-container *ngIf="currentUser.skills.length === 0 && currentUser.interests.length === 0">
                        <small>{{ 'home.widgetConnect.noResultForBoth' | translate }}</small>
                        <p-button
                            label="{{ 'home.widgetConnect.fillProfile' | translate }}"
                            styleClass="p-button-outlined"
                            class="mt-2"
                            (click)="goToMyProfile()"
                        ></p-button>
                    </ng-container>

                    <ng-container *ngIf="currentUser.skills.length === 0">
                        <small>{{ 'home.widgetConnect.noResultForSkills' | translate }}</small>
                        <p-button
                            label="{{ 'home.widgetConnect.fillSkills' | translate }}"
                            styleClass="p-button-outlined"
                            class="mt-2"
                            (click)="goToMyProfile()"
                        ></p-button>
                    </ng-container>

                    <ng-container *ngIf="currentUser.interests.length === 0">
                        <small>{{ 'home.widgetConnect.noResultForInterests' | translate }}</small>
                        <p-button
                            label="{{ 'home.widgetConnect.fillInterests' | translate }}"
                            styleClass="p-button-outlined"
                            class="mt-2"
                            (click)="goToMyProfile()"
                        ></p-button>
                    </ng-container>
                </div>
            </div>
        </ng-template>
    </ng-template>
</div>

<app-profile-modal [(visible)]="isProfileModalVisible" [user]="selectedUser"> </app-profile-modal>
<app-widget-connect-modal
    [(visible)]="isSearchContactModalVisible"
    [user]="selectedUser"
    (searchSubmit)="onSearchSubmit($event)"
></app-widget-connect-modal>
